// extracted by mini-css-extract-plugin
module.exports = {"loaderPage":"styles_loaderPage__zjJ3C","loader":"styles_loader__dw2vi","spin":"styles_spin__S4n6p","pulse":"styles_pulse__op3Ac"};